export default {"src":"/_next/static/media/icon_play_headtohead.188aa299.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};